// extracted by mini-css-extract-plugin
export default {"overlay":"Dialog_overlay__0u8LY","dialog":"Dialog_dialog__BftPb"};